import React, { useState } from "react";

const Button = React.forwardRef(
  (
    {
      children,
      onClick,
      className = "",
      type = "button",
      disabled = false,
      colorKey = "default",
    },
    ref
  ) => {
    // Load color from localStorage (or fallback default)
    const [colorClass, setColorClass] = useState(() => {
      return (
        localStorage.getItem(`buttonColor-${colorKey}`) ||
        "bg-blue-600 text-white hover:bg-blue-700"
      );
    });

    // Function to update color dynamically + persist
    const handleSetColor = (newColorClass) => {
      setColorClass(newColorClass);
      localStorage.setItem(`buttonColor-${colorKey}`, newColorClass);
    };

    return (
      <button
        ref={ref}
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`px-6 py-2 font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-300 disabled:bg-gray-400 ${colorClass} ${className}`}
      >
        {children}
      </button>
    );
  }
);

export default Button;



// import React, { useEffect, useState } from 'react';

// const Button = React.forwardRef(
//   ({ children, onClick, className = '', type = 'button', disabled = false, colorKey = 'default' }, ref) => {
//     const [colorClass, setColorClass] = useState('bg-blue-600 text-white hover:bg-blue-700');

//     // Load color from localStorage
//     useEffect(() => {
//       const savedColor = localStorage.getItem(`buttonColor-${colorKey}`);
//       if (savedColor) {
//         setColorClass(savedColor);
//       }
//     }, [colorKey]);

//     // Optional: function to change button color dynamically
//     const handleSetColor = (newColorClass) => {
//       setColorClass(newColorClass);
//       localStorage.setItem(`buttonColor-${colorKey}`, newColorClass);
//     };

//     return (
//       <button
//         ref={ref} // forward ref
//         type={type}
//         onClick={onClick}
//         disabled={disabled}
//         className={`px-6 py-2 font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-300 disabled:bg-gray-400 ${colorClass} ${className}`}
//       >
//         {children}
//       </button>
//     );
//   }
// );

// export default Button;



// import React from 'react';

// const Button = ({ children, onClick, className = '', type = 'button', disabled = false }) => (
//   <button
//     type={type}
//     onClick={onClick}
//     disabled={disabled}
//     className={`px-6 py-2 font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-300 disabled:bg-gray-400 ${className}`}
//   >
//     {children}
//   </button>
// );

// export default Button;
